import React, { PureComponent } from 'react';
import { BarChart, Bar, Cell, XAxis, YAxis, Legend, ResponsiveContainer } from 'recharts';
import {durationToString} from "../../utils/date";
import "./style.css";


const renderCustomBarLabel = ({ payload, x, y, width, height, value }) => {
  const formatValue = durationToString(value);
  return <text x={x + width / 2} y={y} fill="#666" textAnchor="middle" dy={-6}>{`${formatValue}`}</text>;
};

const renderCustomAxisTick = ({ x, y, payload }) => {
  const formatValue = durationToString(payload.value);
  return <text x={x} y={y} fill="#666" textAnchor="middle">{`${formatValue}`}</text>;
}

const getYaxisTicks = (list) => {
  let max = parseInt(list[0].value);

  for (let i = 1; i < list.length; i++) {
    if (parseInt(list[i].value) > max) {
      max = parseInt(list[i].value);
    }
  }

  const multipleMax = 3600 * (Math.round(max/3600)%2 === 0 ? Math.round(max/3600) + 2 : Math.round(max/3600) + 1);

  return createRange(0, multipleMax, multipleMax <= 3600 * 4 ? multipleMax/2 : multipleMax/4);
}

const createRange = (min, max, step) => {
  const range = [];
  for (let value = min; value <= max; value += step) {
    range.push(value);
  }
  return range;
};

const tickFormatter = (value) => {
  return durationToString(value);
};

const nameLegends = [
  'Time Spent'
];

const renderLegend = (props) => {
  const { payload } = props;
  return (
    <ul className="recharts-default-legend" style={{padding: '0px', margin: '0px', textAlign: 'center'}}>
        {
          payload.map((entry, index) => (
            <li key={`item-legend-${index}`} className={`recharts-legend-item legend-item-${index}`} style={{display: 'inline-block', marginRight: '10px;'}}>
              <svg className="recharts-surface" width="14" height="14" viewBox="0 0 32 32" version="1.1"
                   style={{display: 'inline-block', verticalAlign: 'middle', marginRight: '4px'}}>
                <path stroke="none" fill="#8884d8" d="M0,4h32v24h-32z" className="recharts-legend-icon"></path>
              </svg>
              <span className="recharts-legend-item-text">
                {nameLegends[index]}
              </span>
            </li>
          ))
        }
    </ul>
  );
}

const COUNT_CUSTOMER = 5;

export default class CustomTinyBarChart extends PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      activeIndex: 0
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (this.props.data.length > 0 && nextProps.data.length === 0) {
      return true;
    }

    if (nextProps.data.length === 0) {
      return false;
    }

    return true;
  }

  handleClick = (data, index) => {
    this.setState({
      activeIndex: index,
    });
  };

  render() {
    const { activeIndex, data } = this.state;
    const activeItem = this.props.data[activeIndex];
    const list = this.props.data;

    if (list.length === 0) {
      return null;
    }

    return (
        <div>
          {list.length > COUNT_CUSTOMER &&
              (
                  <div style={{width: '100%'}}>
                    <p className="tip">Click on a bar to see employee name and spent time.</p>
                    <ResponsiveContainer width="100%" height={400}>
                      <BarChart width={600} height={300} data={list}>
                        <Bar dataKey="value" onClick={this.handleClick}>
                          {this.props.data.map((entry, index) => (
                            <Cell cursor="pointer" fill={index === activeIndex ? '#82ca9d' : '#8884d8'} key={`cell-${index}`} />
                          ))}
                        </Bar>
                        <XAxis dataKey="name"/>
                        <Legend content={renderLegend} />
                        <YAxis tickFormatter={tickFormatter} ticks={getYaxisTicks(this.props.data)} />
                      </BarChart>
                    </ResponsiveContainer>
                    <p className="info">{`Time spent by ${activeItem.name}: ${durationToString(activeItem.value)}`}</p>
                  </div>
              )
          }

        {list.length <= COUNT_CUSTOMER &&
          (
            <div style={{width: '100%'}}>
              <ResponsiveContainer width="100%" height={400}>
                <BarChart width={500} height={300} data={list}>
                  <Bar dataKey="value" fill="#8884d8" label={renderCustomBarLabel}/>
                  <XAxis dataKey="name"/>
                  <Legend content={renderLegend} />
                  <YAxis tickFormatter={tickFormatter} ticks={getYaxisTicks(this.props.data)} />
                </BarChart>
              </ResponsiveContainer>
            </div>
          )
        }
        </div>
    )
  };
}




// WEBPACK FOOTER //
// ./src/common/CustomTinyBarChart/index.js